import React, { useCallback, useMemo } from 'react';
import { promptName } from '../../../CodesThatsGottaGoSomewhereElse';
import { LFC } from '../../../Legacy';
import { Point } from '../../../platform/geom/Point';
import { Flexer } from '../../dashboard/elements/LayoutElements';
import { PopoverContext } from '../ui/Popover';
import { InlineWidget } from '../workspace/widgets/WidgetInterface';
import { usePrompt } from './../../../ui';
import { ContextMenuSelector } from './ContextMenuSelector';

export const ContextMenuWidget: LFC<{ widget: InlineWidget }> = ({ widget }) => {

    const position = widget.position as Point;

    const pn = useMemo(() => promptName(), []);

    const onClose = useCallback((e?: any) => {
        if (typeof (e) === 'object') e.preventDefault();
        widget.onClose();
    }, [widget]);

    const promptRef = usePrompt({
        name: pn,
        onAction: onClose,
        ignoreEnter: true,
    });

    return <PopoverContext.Provider value={{ layers: [pn] }}>
        <Flexer ref={promptRef}>
            <Flexer minWidth={20} onContextMenu={onClose}>
                <ContextMenuSelector position={position} onClose={onClose} />
            </Flexer>
        </Flexer>
    </PopoverContext.Provider >;
};
